module.exports = __webpack_public_path__ + "img/1.32b8eb1b.png";